// extracted by mini-css-extract-plugin
module.exports = {"text":"GenericMessage_text__2gkkQ"};